/* tslint:disable */
/* eslint-disable */
/**
 * Geckosoft.Backend.Api | geckosoft-v0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SupplierStatus = {
    Pending: 'pending',
    Active: 'active'
} as const;
export type SupplierStatus = typeof SupplierStatus[keyof typeof SupplierStatus];


export function instanceOfSupplierStatus(value: any): boolean {
    for (const key in SupplierStatus) {
        if (Object.prototype.hasOwnProperty.call(SupplierStatus, key)) {
            if (SupplierStatus[key as keyof typeof SupplierStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SupplierStatusFromJSON(json: any): SupplierStatus {
    return SupplierStatusFromJSONTyped(json, false);
}

export function SupplierStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplierStatus {
    return json as SupplierStatus;
}

export function SupplierStatusToJSON(value?: SupplierStatus | null): any {
    return value as any;
}

export function SupplierStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): SupplierStatus {
    return value as SupplierStatus;
}

